import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';

type TablePrimaryHeaderProps = ComponentProps<'h5'> & {
  namespace: string;
};

/**
 * TablePrimaryHeader component displays the primary header for a results prize table.
 * @param namespace - The namespace for the translations.
 * @returns  Styled heading-5 component with prize table title.
 */
function TablePrimaryHeader({ namespace, ...props }: TablePrimaryHeaderProps) {
  const t = useTranslations(namespace);
  return <h5 {...props}>{t('prize_table')}</h5>;
}

export { TablePrimaryHeader };
